import { render } from "./DinoView.vue?vue&type=template&id=f601564e&scoped=true"
import script from "./DinoView.vue?vue&type=script&lang=js"
export * from "./DinoView.vue?vue&type=script&lang=js"

import "./DinoView.vue?vue&type=style&index=0&id=f601564e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f601564e"

export default script